module.exports = __webpack_public_path__ + "static/img/nocheck_nouse.eb82a525.png";